import { useEffect, useRef, useState } from "react";
import { useSurvey } from "../../../hooks/surveyHooks/useSurvey";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Button, ButtonGroup, Checkbox, IconCamera, IconStar, Modal, RadioButton, RadioButtons, Scrollbar, TextArea } from "@veneer/core";
import { QuestionTypeEnum } from "../../../models/enum/QuestionTypeEnum";
import '../../../assets/css/components/survey.css';
import Webcam from 'react-webcam';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';

export default function SolveSurvey(props: any) {
    const params = useParams();
    const [open, setOpen] = useState(false);
    const [route, setRoute] = useState<any>({});
    const [t] = useTranslation("global");
    const webcamRef: any = useRef(null);
    const [confirmBack, setConfirmBack] = useState(false);
    const [openModalBack, setOpenModalBack] = useState(false);
    const { questions, answers, currentQuestion, saved, show, next, back, showCamera, openModalSave, answersSent, hasCamera, onPressNext, setQuestions,
        onPressPrevious, handleRadioPress, deletePhoto, handleCheckboxPress, handleTextInput, setAnswersSent,
        setCancelSave, setIsSave, handleResetSurvey, handleStarPress, takePhotoFromGallery, setBack, setShowCamera } = useSurvey({ route, webcamRef });

    const handlerBack = () => {
        if (answers.length > 0) {
            setOpenModalBack(true);
            setBack(false);
        } else {
            setOpen(false);
        }
    }


    useEffect(() => {
        if (answersSent) {
            setOpen(false);
            props.onReturnAnswer();
        }
        return () => {
            setAnswersSent(false);
        }
    }, [answersSent])

    useEffect(() => {
        if (props.surveyId !== 0) {
            const id = Number(params.id);
            const obj = { survey: props.questionToShow, surveyId: props.surveyId, surveyName: "", appointmentActivityID: id, posCode: props.pos };
            setRoute(obj);
            setQuestions(obj.survey);
            setOpen(true);
        }
    }, [props]);

    useEffect(() => {
        if (confirmBack) {
            setOpen(false);
            setOpenModalBack(false);
            handleResetSurvey();
        }
        return () => {
            setConfirmBack(false);
        }
    }, [confirmBack])

    return (
        <div style={{ position: 'relative' }}>
            {
                questions.length > 0 &&
                !back && (
                    <Modal
                        align="start"
                        id="modal-id"
                        show={openModalBack}
                        footer={(
                            <div style={{ display: "flex", textAlign: "right", width: "100%" }}>
                                <div style={{ width: "50%", marginRight: "3px", textAlign: "right" }} >
                                    <Button onClick={() => setConfirmBack(true)}>{t('header.confirm')}</Button>
                                </div>
                                <div style={{ width: "50%", marginRight: "3px", textAlign: "left" }} >
                                    <Button onClick={() => setBack(true)} appearance="secondary">{t('header.cancel')}</Button>
                                </div>
                            </div>

                        )}
                        title={t("modal.warningTitle")}
                    >
                        <p>
                            {t("modal.warningMessage")}
                        </p>
                    </Modal>
                ) || (
                    saved ? (
                        <Modal
                            align="start"
                            id="modal-id"
                            show={openModalSave}
                            footer={(
                                <div style={{ display: "flex", textAlign: "right", width: "100%" }}>
                                    <div style={{ width: "50%", marginRight: "3px", textAlign: "right" }} >
                                        <Button onClick={() => setIsSave(true)}>{t('header.confirm')}</Button>
                                    </div>
                                    <div style={{ width: "50%", marginRight: "3px", textAlign: "left" }} >
                                        <Button onClick={() => setCancelSave(true)} appearance="secondary">{t('header.cancel')}</Button>
                                    </div>
                                </div>
                            )}
                            title={t("modal.saveTitleInfo")}
                        >
                            <p>
                                {t("modal.saveMessage")}
                            </p>
                        </Modal>
                    ) :
                        <div>
                            <div style={{ padding: '20px' }}>
                                <div style={{ position: 'relative' }}>
                                    <Modal
                                        align="start"
                                        id="modal-id"
                                        closeButton
                                        css={{
                                            '.vn-modal--content': {
                                                width: 800,
                                                height: '90vh',
                                            },
                                        }}
                                        show={open}
                                        onClose={handlerBack}
                                        footer={(
                                            <div style={{ textAlign: "center" }} >
                                                {
                                                    show && (
                                                        currentQuestion === 0 ? (
                                                            <div>
                                                                {
                                                                    next ? (
                                                                        <div>
                                                                            <Button
                                                                                onClick={onPressNext}
                                                                            >
                                                                                {t("header.nextButton")}
                                                                            </Button>
                                                                        </div>
                                                                    ) : (
                                                                        <div>
                                                                            <Button
                                                                                onClick={onPressNext}
                                                                                disabled
                                                                            >
                                                                                {t("header.nextButton")}
                                                                            </Button>
                                                                        </div>
                                                                    )
                                                                }

                                                            </div>
                                                        ) : (
                                                            <div style={{ display: "flex", textAlign: "right" }}>
                                                                <div style={{ width: "50%", marginRight: "3px", textAlign: "right" }} >
                                                                    <Button
                                                                        onClick={onPressPrevious}
                                                                    >
                                                                        {t("header.previousButton")}
                                                                    </Button>
                                                                </div>
                                                                <div style={{ width: "50%", textAlign: "left", marginLeft: "3px" }}>
                                                                    {
                                                                        next ? (
                                                                            <Button
                                                                                onClick={onPressNext}
                                                                            >
                                                                                {t("header.nextButton")}
                                                                            </Button>
                                                                        ) : (
                                                                            <Button
                                                                                disabled
                                                                            >
                                                                                {t("header.nextButton")}
                                                                            </Button>
                                                                        )
                                                                    }

                                                                </div>
                                                            </div>
                                                        )
                                                    )
                                                }
                                            </div>
                                        )}
                                    >
                                        <>
                                            <div>
                                                {
                                                    <h5>
                                                        {
                                                            show && (
                                                                <div>
                                                                    {
                                                                        questions[currentQuestion]?.MandatoryQuestion &&
                                                                        (
                                                                            <label style={{ color: "red", fontSize: "20 / fontScale", fontFamily: 'BeVietnamPro-Medium' }}>{`* `}</label>
                                                                        )
                                                                    }
                                                                    <label>
                                                                        {
                                                                            questions[currentQuestion]?.Question
                                                                        }
                                                                    </label>
                                                                </div>
                                                            )
                                                        }
                                                    </h5>
                                                }
                                                <br />
                                            </div>
                                            <div style={{ display: "flex", textAlign: "right", width: "100%" }}>
                                                <Scrollbar
                                                    css={{
                                                        height: '60vh',
                                                        overflow: 'auto',
                                                        width: '70%',
                                                    }}
                                                >
                                                    <div style={{ width: "70%", textAlign: "left", marginLeft: '5%' }}>
                                                        <div style={{ margin: '2%' }}>
                                                            {
                                                                show && questions[currentQuestion]?.Type === QuestionTypeEnum.text && (
                                                                    <div style={{ width: "420px", marginTop: '10%' }}>
                                                                        <TextArea
                                                                            id="textArea"
                                                                            height="200px"
                                                                            multiline={true}
                                                                            onChange={text => handleTextInput(text)}
                                                                            value={answers.filter((answer) => answer.id === currentQuestion)[0]?.answer.toString() || ''}
                                                                            placeholder={t("header.answer")}
                                                                        />
                                                                    </div>
                                                                )
                                                            }
                                                        </div>

                                                        {
                                                            show && questions[currentQuestion]?.Type === QuestionTypeEnum.checkbox && (
                                                                questions[currentQuestion].Options.map((item, index) => {
                                                                    return (
                                                                        <div key={index} style={{ marginBottom: '10px' }}>
                                                                            <Checkbox
                                                                                style={{ marginBottom: '10px' }}
                                                                                id="checkbox"
                                                                                checked={item.selected}
                                                                                onClick={() => { handleCheckboxPress(item.Option, index.toString()) }}
                                                                                label={item.Option}
                                                                            />
                                                                            <br />
                                                                        </div>
                                                                    )
                                                                })
                                                            )
                                                        }
                                                        {
                                                            show && questions[currentQuestion]?.Type === QuestionTypeEnum.radio &&
                                                            <div>
                                                                {
                                                                    questions[currentQuestion].Options.map((item, index) => {
                                                                        return (
                                                                            <div key={index}>
                                                                                <FormControlLabel
                                                                                    checked={item.selected}
                                                                                    value={item.Option}
                                                                                    control={<Radio />}
                                                                                    label={item.Option}
                                                                                    onClick={() => { handleRadioPress(item.Option, index.toString()) }}
                                                                                    sx={{
                                                                                        '& .MuiSvgIcon-root': {
                                                                                            fontSize: 26,
                                                                                        },
                                                                                    }} />
                                                                            </div>
                                                                        )
                                                                    })
                                                                }
                                                            </div>

                                                        }
                                                        {
                                                            show && questions[currentQuestion]?.Type === QuestionTypeEnum.star && (
                                                                <div style={{ textAlign: "center" }}>
                                                                    {
                                                                        questions[currentQuestion].Options.map((option, index) => (
                                                                            <IconStar key={index} onClick={() => handleStarPress(option.Option, index.toString())} size={40} className={option.selected ? 'starSelected' : 'zoom'} filled={option.selected} />
                                                                        ))}
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                </Scrollbar>
                                                <div style={{ width: "30%", textAlign: "right", marginTop: '5%' }}>
                                                    {
                                                        hasCamera ? (
                                                            <div>
                                                                {
                                                                    answers.filter((answer) => answer.id === currentQuestion)[0]?.photo !== undefined &&
                                                                        answers.filter((answer) => answer.id === currentQuestion)[0]?.photo !== null ? (
                                                                        <div style={{ textAlign: "center" }}>
                                                                            <img
                                                                                src={answers.filter((answer) => answer.id === currentQuestion)[0]?.photo?.toString()}
                                                                                style={{ width: 200, height: 150, borderRadius: 10 }}
                                                                            />
                                                                            <br />
                                                                            <Button small onClick={() => deletePhoto()}>{t("header.delete")}</Button>
                                                                        </div>
                                                                    ) : (
                                                                        <div style={{ textAlign: "center" }}>
                                                                            {
                                                                                showCamera ?
                                                                                    <>
                                                                                        <Webcam
                                                                                            audio={false}
                                                                                            ref={webcamRef}
                                                                                            screenshotFormat="image/jpeg"
                                                                                            width={200}
                                                                                            height={150}
                                                                                            frameBorder={10}
                                                                                        />
                                                                                        <Button small onClick={takePhotoFromGallery}>{t("header.takePhoto")}</Button>
                                                                                    </>
                                                                                    :
                                                                                    <IconCamera onClick={() => setShowCamera(true)} size={72} />
                                                                            }
                                                                            <br />
                                                                        </div>
                                                                    )
                                                                }
                                                                <br />
                                                                <div style={{ textAlign: "center", marginTop: '1%' }}>
                                                                    {
                                                                        show && questions[currentQuestion]?.MandatoryPhoto ? (
                                                                            <label style={{ color: '#FF0000', fontSize: "12 / fontScale" }}>{t("header.obligatoryPhoto")}</label>
                                                                        ) : (
                                                                            <label style={{ fontSize: "12 / fontScale" }}>{t("header.photoNotRequired")}</label>
                                                                        )
                                                                    }
                                                                </div>
                                                            </div>) :
                                                            (
                                                                <div>
                                                                    <div style={{ textAlign: "center", marginTop: '1%' }}>
                                                                        <IconCamera disabled onClick={() => setShowCamera(true)} size={72} />
                                                                    </div>
                                                                    <div style={{ textAlign: "center", marginTop: '1%' }}>
                                                                        <label style={{ fontSize: "12 / fontScale" }}>{t("header.doesNotHaveCamera")}</label>
                                                                    </div>
                                                                </div>
                                                            )
                                                    }
                                                </div>
                                            </div>
                                        </>
                                    </Modal>
                                </div>
                            </div>
                        </div >
                )
            }
        </div >
    );
}